import { options, optionsCrypto } from "./../helpers/CountryList";

export const currensys = options.flatMap(a =>
    options.filter(b => b.value !== a.value).map(b => a.value + b.value)
);

const VALID_CURRENCY_CODES = options.map(o => o.value);

export function isValidFiatPair(curencies) {
    if (!curencies) return false;
    const parts = curencies.split("-");
    if (parts.length !== 2) return false;
    const [c1, c2] = parts.map(c => c.toUpperCase());
    return VALID_CURRENCY_CODES.includes(c1) && VALID_CURRENCY_CODES.includes(c2);
}

const CRYPTO_CODES = optionsCrypto.map(o => o.value.toUpperCase());

export function isValidCryptoPair(curencies) {
    if (!curencies) return false;
    const parts = curencies.toUpperCase().split("-");
    if (parts.length !== 2) return false;
    const [c1, c2] = parts;
    const known = c => CRYPTO_CODES.includes(c) || VALID_CURRENCY_CODES.includes(c);
    const hasCrypto = CRYPTO_CODES.includes(c1) || CRYPTO_CODES.includes(c2);
    return hasCrypto && known(c1) && known(c2);
}

export function isValidAmount(amount) {
    return !!amount && !isNaN(Number(amount)) && Number(amount) > 0;
}



export const LANGUAGES = [
    { common: "en", name: "United Kingdom", lang: "flag_24 en" },
    { common: "ru", name: "Russia", lang: "flag_24 ru" },
    { common: "es", name: "Spain", lang: "flag_24 es" },
    { common: "pt", name: "Portugal", lang: "flag_24 pt" },
    { common: "ar", name: "Saudi Arabia", lang: "flag_24 ar" },
    { common: "tr", name: "Turkey", lang: "flag_24 tr" },
    { common: "fa", name: "Iran", lang: "flag_24 fa" },
    { common: "vi", name: "Vietnam", lang: "flag_24 vi" },
    { common: "ja", name: "Japan", lang: "flag_24 ja" },
    { common: "zh", name: "Taiwan", lang: "flag_24 zh" },
    { common: "zh_cn", name: "China", lang: "flag_24 zh_cn" },
    { common: "id", name: "Indonesia", lang: "flag_24 id" },
    { common: "fr", name: "France", lang: "flag_24 fr" },
    { common: "cs", name: "Czech Republic", lang: "flag_24 cs" },
    { common: "hi", name: "India", lang: "flag_24 hi" },
    { common: "it", name: "Italy", lang: "flag_24 it" },
    { common: "ms", name: "Malaysia", lang: "flag_24 ms" },
];

export const SUPPORTED_LANGUAGES = LANGUAGES.map(l => l.common);
const LANG_PATTERN = SUPPORTED_LANGUAGES.join("|");

export const MAIN_ROUTE = "/";
export const MAIN_ROUTE_BY_LANGUAGE = `/:language(${LANG_PATTERN})`;
export const MAIN_ROUTE_BY_LANGUAGE__FUNC = language => `/${language}`;

export const CRYPTO_ROUTE = `/:language(${LANG_PATTERN})/crypto-converter`;
export const CRYPTO_ROUTE_MAKER = language => `/${language}/crypto-converter`;

export const MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_CRYPTO = `/:language(${LANG_PATTERN})/crypto-converter/:curencies`;
export const MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT_CRYPTO = `/:language(${LANG_PATTERN})/crypto-converter/:curencies/:amount`;

export const LANDING_ROUTE = `/:language(${LANG_PATTERN})/landing-canada`;
export const LANDING_ROUTE_MAKER = language => `/${language}/crypto-converter`;

export const LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES = `/:language(${LANG_PATTERN})/landing-canada/:curencies`;
export const LANDING_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUNT = `/:language(${LANG_PATTERN})/landing-canada/:curencies/:amount`;

export const CALCULATOR_ROUTE = `/:language(${LANG_PATTERN})/forex-calculator`;
export const CALCULATOR_ROUTE_MAKER = language => `/${language}/forex-calculator`;

export const CURRENCY_ROUTE = `/:language(${LANG_PATTERN})/currencies-and-abbreviations`;
export const CURRENCY_ROUTE_MAKER = language => `/${language}/currencies-and-abbreviations`;

export const PROFIT_LOSS_ROUTE = `/:language(${LANG_PATTERN})/forex-calculator/profitloss-calculation`;
export const PROFIT_LOSS_ROUTE_MAKER = language => `/${language}/forex-calculator/profitloss-calculation`;

export const MARGIN_ROUTE = `/:language(${LANG_PATTERN})/forex-calculator/margin-calculation`;
export const MARGIN_ROUTE_MAKER = language => `/${language}/forex-calculator/margin-calculation`;

export const MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES = `/:language(${LANG_PATTERN})/:curencies`;
export const MAIN_ROUTE_WITH_LANGUAGE_AND_CURRENCIES_AND_AMOUT = `/:language(${LANG_PATTERN})/:curencies/:amount`;

export const WEB_SOCKET_URL = "wss://q.ifccd.net";